import { render, staticRenderFns } from "./MarketItem.vue?vue&type=template&id=3ea7abed&scoped=true"
import script from "./MarketItem.vue?vue&type=script&lang=js"
export * from "./MarketItem.vue?vue&type=script&lang=js"
import style0 from "./MarketItem.vue?vue&type=style&index=0&id=3ea7abed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea7abed",
  null
  
)

export default component.exports